"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Speeding.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Speeding = function Speeding(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 197.5 197.5"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Speeding Icon"), _react2.default.createElement("g", {
    className: "speeding",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "circle",
    d: "M98.75 0a98.75 98.75 0 1 0 98.75 98.75A98.75 98.75 0 0 0 98.75 0zm0 186.3a87.56 87.56 0 1 1 87.55-87.57 87.56 87.56 0 0 1-87.55 87.57z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "speed-lines",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "line",
    d: "M137.3 132.54H77.8a4.56 4.56 0 0 1-4.59-5.54 7 7 0 0 1 6.55-5.57h59.5a4.56 4.56 0 0 1 4.59 5.57 7 7 0 0 1-6.55 5.54z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "line-2",
    d: "M142.28 104.32h-94a4.56 4.56 0 0 1-4.59-5.57 7 7 0 0 1 6.55-5.57h94a4.56 4.56 0 0 1 4.59 5.57 7 7 0 0 1-6.55 5.57z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "line-3",
    d: "M147.25 76.09h-47a4.56 4.56 0 0 1-4.59-5.57 7 7 0 0 1 6.55-5.57h47a4.56 4.56 0 0 1 4.59 5.57 7 7 0 0 1-6.55 5.57z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20
    },
    __self: undefined
  }))));
};
exports.default = Speeding;